import React, { useState } from 'react';
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Tabs,
    Tab,
    Stack
} from '@mui/material';
import {
    Close as CloseIcon,
} from '@mui/icons-material';
import AddMedicineDrawer from './AddMedicineDrawer';
import AddServiceForm from './AddServiceForm';

const AddProductDrawer = ({ open, onClose, selectedProduct, onProductAdded }) => {
    const [activeTab, setActiveTab] = useState(0);

    // Determinar la pestaña inicial según el tipo de producto
    React.useEffect(() => {
        if (selectedProduct) {
            setActiveTab(selectedProduct.type === 'service' ? 1 : 0);
        } else {
            setActiveTab(0);
        }
    }, [selectedProduct]);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const handleClose = () => {
        setActiveTab(0); // Resetear a la primera pestaña
        onClose();
    };

    // Si estamos editando un servicio
    if (selectedProduct && selectedProduct.type === 'service') {
        return (
            <AddServiceForm
                open={open}
                onClose={handleClose}
                selectedService={selectedProduct}
                onServiceAdded={onProductAdded}
                isEditMode={true}
            />
        );
    }

    // Si estamos editando un consumible
    if (selectedProduct && selectedProduct.type === 'consumible') {
        return (
            <AddMedicineDrawer
                open={open}
                onClose={handleClose}
                selectedMedicine={selectedProduct}
                onMedicineAdded={onProductAdded}
                isEditMode={true}
            />
        );
    }

    // Modo creación: mostrar pestañas
    return (
        <Drawer anchor="right" open={open} onClose={handleClose} sx={{ zIndex: 1300 }}>
            <Box sx={{ width: 450, height: '100vh', display: 'flex', flexDirection: 'column' }}>
                {/* Header */}
                <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="h5" sx={{ fontWeight: 600 }}>
                            Add New Product
                        </Typography>
                        <IconButton onClick={handleClose} size="large">
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                </Box>

                {/* Tabs */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs 
                        value={activeTab} 
                        onChange={handleTabChange}
                        variant="fullWidth"
                    >
                        <Tab label="Consumibles" />
                        <Tab label="Services" />
                    </Tabs>
                </Box>

                {/* Content */}
                <Box sx={{ flex: 1, overflow: 'hidden' }}>
                    {activeTab === 0 ? (
                        <AddMedicineDrawer
                            open={open}
                            onClose={handleClose}
                            selectedMedicine={null}
                            onMedicineAdded={onProductAdded}
                            embedded={true}
                        />
                    ) : (
                        <AddServiceForm
                            open={open}
                            onClose={handleClose}
                            selectedService={null}
                            onServiceAdded={onProductAdded}
                            embedded={true}
                        />
                    )}
                </Box>
            </Box>
        </Drawer>
    );
};

export default AddProductDrawer;